import * as vp from 'vopay';
import { FunctionComponent, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import usePostSetFlinksCredentials from '../../../../hooks/useApi/usePostSetFlinksCredentials';

import UpdateFlinksForm from './UpdateFlinksForm';
import UpdateFlinksReview from './UpdateFlinksReview';
import UpdateFlinksContext, { UpdateFlinksCtx } from './Dialogue/UpdateFlinksContext';
import UpdateFlinksDialogue from './Dialogue/UpdateFlinksDialogue';
import { UpdateFlinksDialogueHandler, DialogueHandlerProps } from './Dialogue/types';
import { useClientData } from '../../../../providers/ClientData.provider';

type FC = FunctionComponent;

const UpdateFlinksContainer: FC = () => {
  const history = useHistory();
  const [UpdateError, setUpdateError] = useState('');
  const [showUpdateErrorAlert, setShowUpdateErrorAlert] = useState(false);
  const [showUpdateSuccessAlert, setShowUpdateSuccessAlert] = useState(false);
  const [shouldUpdateFlinks, setShouldUpdateFlinks] = useState(false);
  const [setFlinksCredentialsResponse, setFlinksCredentials] = usePostSetFlinksCredentials({});

  const [review, setReview] = useState(false);
  const { response } = useClientData();
  const [FlinksRequest, setFlinksRequest] = useState<vp.SetFlinksCredentialsRequest>({
    FlinksUrl: '',
    PortalUser: response.LoginUserName,
  });

  const UpdateFlinks: UpdateFlinksCtx = {
    showUpdateSuccessAlert,
    showUpdateErrorAlert,
    UpdateError,
  };
  const handlers = {
    handleDialogue: (handlerProps: DialogueHandlerProps<UpdateFlinksDialogueHandler>) => {
      const { type, state, action = 'default' } = handlerProps;

      const dialogueHandlers: UpdateFlinksDialogueHandler = {
        update: {
          success: {
            default: () => {
              setShowUpdateSuccessAlert(false);
              history.push('/integrations/Flinks');
            },
          },
          error: {
            default: () => {
              setShowUpdateErrorAlert(false);
              setUpdateError('');
            },
          },
        },
      };
      const dialogueState = dialogueHandlers[type][state];
      const handler = dialogueState[action] || dialogueState.default;

      handler();
    },
    onReview: (values: vp.SetFlinksCredentialsRequest) => {
      setReview(true);
      setFlinksRequest(values);
    },
    onUpdate: (values: vp.SetFlinksCredentialsRequest) => {
      setShouldUpdateFlinks(true);

      setFlinksCredentials(values);
    },
    onBack: () => {
      setReview(false);
    },
  };

  useEffect(() => {
    if (shouldUpdateFlinks) {
      setShouldUpdateFlinks(false);

      if (setFlinksCredentialsResponse?.Success === true) {
        setShowUpdateSuccessAlert(true);
      } else {
        setUpdateError(setFlinksCredentialsResponse?.ErrorMessage || '');
        setShowUpdateErrorAlert(true);
      }
    }
  }, [setFlinksCredentialsResponse]);

  return (
    <UpdateFlinksContext.Provider value={UpdateFlinks}>
      {!review && <UpdateFlinksForm defaultValues={FlinksRequest} onSubmit={handlers.onReview} />}
      {review && (
        <UpdateFlinksReview defaultValues={FlinksRequest} onSubmit={handlers.onUpdate} onBack={handlers.onBack} />
      )}
      <UpdateFlinksDialogue handleDialogue={handlers.handleDialogue} />
    </UpdateFlinksContext.Provider>
  );
};

export default UpdateFlinksContainer;
